module.exports = __webpack_public_path__ + "static/media/add_round.430361e8.svg";